<template>
  <div id="lysearch">
    <Input
      :value="keyWork"
      :placeholder="placeholder ? placeholder : '请输入关键词'"
      clearable
      @input="change"
      v-bind="$attrs"
    >
      <template #append>
        <Button @click="search" icon="ios-search"></Button>
      </template>
    </Input>
  </div>
</template>
<script>
var t;
export default {
  props: ["keyWork", "placeholder"],
  methods: {
    search() {
      this.$emit("search");
    },
    change(v) {
      clearTimeout(t);
      t = setTimeout(() => {
        this.search();
      }, 500);
      this.$emit("aaa", v);
      //this.$emit("change", v);
    },
  },
  model: {
    prop: "keyWork",
    event: "aaa",
  },
};
</script>
<style lang="">
#lysearch {
  display: flex;
}
</style>


// WEBPACK FOOTER //
// ../common/src/components/lySearch.vue